import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function SpecialRouteRedirect() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(
      {
        pathname: `/${i18n.language}${location.pathname}`,
        search: location.search,
      },
      { replace: true }
    );
  }, [i18n.language, location.pathname, location.search, navigate]);

  return null;
}

export default SpecialRouteRedirect;
